// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wRRTI","top":"styles_top__1CkWM"};